(() => {
  if (window.dkxFjarelaReady) return;
  window.dkxFjarelaReady = true;
  const root = () => window.Shopify?.routes?.root || '/';
  const getCart = () => fetch(root() + 'cart.js', {headers:{Accept:'application/json'}}).then(r=>r.json());
  async function refreshCart(state) {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && state.sections?.['cart-drawer']) {
      drawer.classList.toggle('is-empty',state.item_count === 0);
      drawer.renderContents(state);
    } else {
      location.assign(root() + 'cart');
    }
  }
  window.dkxFjarelaRefreshCart = refreshCart;
  window.dkxFjarelaBundleChange = async (bundle, quantity, sections) => {
    const cart = await getCart();
    const updates = {};
    for (const item of cart.items) {
      if (item.properties?._dkx_bundle === bundle) updates[item.key] = quantity;
    }
    const response = await fetch(root()+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({updates,sections,sections_url:location.pathname})});
    if (!response.ok) throw new Error('Cart update failed');
    return response;
  };
  document.addEventListener('click',async event => {
    const mediaButton=event.target.closest('[data-df-media]');
    if(mediaButton){
      const gallery=mediaButton.closest('media-gallery');gallery?.setActiveMedia(mediaButton.dataset.dfMedia,false);
      gallery?.querySelectorAll('[data-df-media]').forEach(button=>button.setAttribute('aria-current',String(button===mediaButton)));
    }
    const button = event.target.closest('[data-df-add]');
    if (button) {
      if (button.disabled) return;
      button.disabled = true;
      try {
        const response = await fetch(root()+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:Number(button.dataset.dfAdd),quantity:1}],sections:['cart-drawer','cart-icon-bubble'],sections_url:location.pathname})});
        const state = await response.json();
        if (!response.ok) throw new Error(state.description || 'Cart add failed');
        await refreshCart(state);
      } catch (error) {
        const notice = document.createElement('p'); notice.setAttribute('role','alert'); notice.textContent=window.cartStrings?.error || error.message;
        button.parentElement.append(notice);
      } finally {button.disabled=false;}
    }
    if (event.target.closest('[data-df-sticky-add]')) {
      document.querySelector('product-info product-form [type=submit]')?.click();
    }
    if (event.target.closest('[data-df-product-scroll]')) {
      document.querySelector('product-info')?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
    }
  });
  function sticky() {
    const bar=document.querySelector('[data-df-sticky]');
    const form=document.querySelector('.product__info-wrapper');
    if (!bar || !form || bar.dataset.ready) return;
    bar.dataset.ready='true';
    const prices=JSON.parse(bar.querySelector('[data-df-sticky-variants]')?.textContent || '{}');
    const updatePrice=variantId=>{
      const price=prices[variantId],label=bar.querySelector('[data-df-sticky-price]');
      if(!price || !label)return;
      label.textContent=price.price;
      if(price.compare){const old=document.createElement('s');old.textContent=price.compare;label.append(' ',old);}
    };
    document.querySelector('product-info')?.addEventListener('change',()=>updatePrice(document.querySelector('product-info product-form [name=id]')?.value));
    if(typeof subscribe==='function' && typeof PUB_SUB_EVENTS!=='undefined')subscribe(PUB_SUB_EVENTS.variantChange,event=>updatePrice(event.data?.variant?.id));
    new IntersectionObserver(entries => {bar.hidden=entries[0].isIntersecting || entries[0].boundingClientRect.top > 0;},{threshold:0}).observe(form);
  }
  function carousels(){
    document.querySelectorAll('[data-df-carousel]').forEach(carousel=>{
      if(carousel.dataset.ready)return;carousel.dataset.ready='true';
      const track=carousel.querySelector('[data-df-track]');if(!track)return;
      const dots=[...carousel.querySelectorAll('[data-df-dot]')];
      const index=()=>Math.round(track.scrollLeft/track.clientWidth);
      const move=i=>track.scrollTo({left:i*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      carousel.querySelector('[data-df-prev]')?.addEventListener('click',()=>move(Math.max(0,index()-1)));
      carousel.querySelector('[data-df-next]')?.addEventListener('click',()=>move(Math.min(track.children.length-1,index()+1)));
      dots.forEach((dot,i)=>dot.addEventListener('click',()=>move(i)));
      const update=()=>{dots.forEach((dot,i)=>dot.setAttribute('aria-current',String(i===index())));const prev=carousel.querySelector('[data-df-prev]'),next=carousel.querySelector('[data-df-next]');if(prev)prev.disabled=index()===0;if(next)next.disabled=index()>=track.children.length-1;if(carousel.classList.contains('df-product-reviews')){const active=track.children[index()];if(active)track.style.height=active.offsetHeight+'px';}};
      if(carousel.classList.contains('df-product-reviews')){new ResizeObserver(update).observe(track.children[0]);document.fonts.ready.then(update);}
      track.addEventListener('scroll',update,{passive:true});update();
    });
  }
  carousels();document.addEventListener('shopify:section:load',carousels);
  document.querySelectorAll('media-gallery').forEach(gallery=>gallery.addEventListener('slideChanged',event=>{
    const active=event.detail?.currentElement?.dataset.mediaId;
    if(active)gallery.querySelectorAll('[data-df-media]').forEach(button=>button.setAttribute('aria-current',String(button.dataset.dfMedia===active)));
  }));
  sticky(); document.addEventListener('shopify:section:load',sticky);
})();
